import { useSelector } from "react-redux";
import TableHeaderCell from "../../common/table/tableHeaderCell";
import { t } from "i18next";
import { useAppDispatch } from "../../../redux";
import { onClickOrder } from "../../../utils/helpers";
import {
  getSurveyReport,
  updateOrder,
  updateOrderAs,
  updatePage,
} from "../../../redux/reducer/surveyReportReducer";

const TableHeader = () => {
  const dispatch = useAppDispatch();

  const { surveysReport } = useSelector((state: any) => state);
  const { orderBy, orderAs } = surveysReport;

  const OnClickOrder = async (orderType: string) => {
    const { orderOption, listOrderAs } = onClickOrder(
      orderBy,
      orderAs,
      orderType
    );
    dispatch(updateOrder(orderOption));
    dispatch(updateOrderAs(listOrderAs));
    dispatch(updatePage(1));
    dispatch(getSurveyReport());
  };

  const getIcon = (orderType: String) => {
    let icon = "unfold_more";

    if (orderBy === orderType) {
      if (orderAs === "desc") {
        icon = "keyboard_arrow_up";
      } else {
        icon = "keyboard_arrow_down";
      }
    }
    return icon;
  };

  return (
    <thead>
      <tr>
        <TableHeaderCell
          className="regionalCodeWidth"
          icon={getIcon("campaign")}
          onClickOrder={() => {
            OnClickOrder("campaign");
          }}
          label={t("campaign")}
        />
        <TableHeaderCell
          icon={getIcon("name")}
          onClickOrder={() => {
            OnClickOrder("name");
          }}
          label={t("headerSection.question")}
        />
        <TableHeaderCell
          icon={getIcon("surveyAnswers")}
          onClickOrder={() => {
            OnClickOrder("surveyAnswers");
          }}
          label={t("no-of-question")}
        />
      </tr>
    </thead>
  );
};

export default TableHeader;
